module.exports = __webpack_public_path__ + "img/icon-add-light-white.205638cd.svg";